module.exports = __webpack_public_path__ + "media/images/shadow_closed-0a33ea7fcf8a658540ba4d353fda8366.jpg";